module.exports = __webpack_public_path__ + "lt.svg?c6061ef65513d67b7f8295e1570b88e1";